import styles from './style.module.scss';
function LoaderDot() {
    return (
        <div className={styles.bodyLoader}>
            <span className={styles.loader}></span>
        </div>
    );
}

export default LoaderDot;
